/* SALITE Lookbook – Fotowettbewerb (Galerie, Timer, Upload, Likes, Admin)
   Benötigt window.SAL_LB = { url, key, lang } und auf Seite/Admin die supabase-js UMD. */
(function () {
  'use strict';
  var CFG = window.SAL_LB || {};
  var DE = (CFG.lang || document.documentElement.lang || 'de').slice(0, 2) === 'de';
  var T = DE ? {
    endsIn: 'Einsendephase endet in', startsIn: 'Nächste Einsendephase startet in', ended: 'Einsendephase beendet',
    soon: 'Die nächste Einsendephase wird bald angekündigt.', d: 'Tage', h: 'Std', m: 'Min', s: 'Sek',
    empty: 'Noch keine Bilder freigegeben. Sei die erste Person im Lookbook.',
    winner: 'Gewinner', likes: 'Likes', like: 'Liken', liked: 'Geliked',
    emailText: 'Wir schicken dir einen 6-stelligen Code. Damit kannst du Bilder einreichen und liken – ohne Passwort.',
    likeNeedsLogin: 'Bestätige kurz deine E-Mail, um zu liken. Pro Person zählt ein Like pro Bild.',
    codeSent: 'Code gesendet an', wrongCode: 'Der Code stimmt nicht oder ist abgelaufen.', rate: 'Bitte warte kurz und versuche es dann noch einmal.',
    pick: 'Foto auswählen', change: 'Anderes Foto',
    cTerms: 'Ich akzeptiere die <a href="{terms}" target="_blank">Teilnahmebedingungen</a> und die <a href="{privacy}" target="_blank">Datenschutzerklärung</a>.',
    cRights: 'Das Foto ist von mir. Alle abgebildeten Personen sind einverstanden, dass SALITE das Bild im Lookbook und auf Social Media zeigt.',
    send: 'Einreichen', sending: 'Wird hochgeladen …', thanks: 'Danke! Wir prüfen dein Bild. Sobald es freigegeben ist, erscheint es im Lookbook.',
    mine: 'Deine Einsendungen', st_pending: 'In Prüfung', st_approved: 'Online', st_rejected: 'Abgelehnt',
    limit: 'Du hast die maximale Anzahl an Einsendungen erreicht.', closed: 'Die Einsendephase ist gerade nicht aktiv.',
    needPhoto: 'Bitte wähle ein Foto aus.', needConsent: 'Bitte bestätige beide Häkchen.', needName: 'Bitte gib einen Namen an.',
    error: 'Etwas ist schiefgelaufen. Bitte versuche es noch einmal.', logout: 'Abmelden', loggedAs: 'Angemeldet als',
    prize: 'Gewinn', ownLike: 'Dein eigenes Bild kannst du nicht liken.'
  } : {
    endsIn: 'Submissions close in', startsIn: 'Next submission phase starts in', ended: 'Submission phase closed',
    soon: 'The next submission phase will be announced soon.', d: 'Days', h: 'Hrs', m: 'Min', s: 'Sec',
    empty: 'No looks approved yet. Be the first one in the lookbook.',
    winner: 'Winner', likes: 'Likes', like: 'Like', liked: 'Liked',
    emailText: 'We will send you a 6-digit code. With it you can submit and like looks – no password needed.',
    likeNeedsLogin: 'Quickly confirm your email to like. One like per person per look.',
    codeSent: 'Code sent to', wrongCode: 'The code is wrong or has expired.', rate: 'Please wait a moment and try again.',
    pick: 'Choose photo', change: 'Choose another photo',
    cTerms: 'I accept the <a href="{terms}" target="_blank">terms of participation</a> and the <a href="{privacy}" target="_blank">privacy policy</a>.',
    cRights: 'I took this photo. Everyone shown agrees that SALITE may show it in the lookbook and on social media.',
    send: 'Submit', sending: 'Uploading …', thanks: 'Thank you! We are reviewing your photo. Once approved it will appear in the lookbook.',
    mine: 'Your submissions', st_pending: 'In review', st_approved: 'Live', st_rejected: 'Declined',
    limit: 'You have reached the maximum number of submissions.', closed: 'The submission phase is not active right now.',
    needPhoto: 'Please choose a photo.', needConsent: 'Please confirm both checkboxes.', needName: 'Please enter a name.',
    error: 'Something went wrong. Please try again.', logout: 'Log out', loggedAs: 'Logged in as',
    prize: 'Prize', ownLike: 'You cannot like your own look.'
  };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pubUrl(path, small) { if (!path) return ''; var p = small ? path.replace(/\.jpg$/, '-s.jpg') : path; return CFG.url + '/storage/v1/object/public/lookbook-public/' + p; }
  function rest(path) { return fetch(CFG.url + '/rest/v1/' + path, { headers: { apikey: CFG.key, Authorization: 'Bearer ' + CFG.key } }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  // cur = zuletzt gestartete Phase (läuft oder beendet), upcoming = nächste geplante
  function pickContest(list) {
    var now = Date.now(), cur = null, next = null;
    (list || []).forEach(function (c) {
      var s = Date.parse(c.starts_at);
      if (s <= now && (!cur || s > Date.parse(cur.starts_at))) cur = c;
      if (s > now && (!next || s < Date.parse(next.starts_at))) next = c;
    });
    return { contest: cur, upcoming: next };
  }
  function phase(c) { if (!c) return 'none'; var n = Date.now(); if (n < Date.parse(c.starts_at)) return 'before'; if (n < Date.parse(c.ends_at)) return 'open'; return 'ended'; }

  /* ---------- Countdown ---------- */
  function countdown(el, target, onDone) {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    var iv;
    function tick() {
      var diff = Math.max(0, Date.parse(target) - Date.now());
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      el.innerHTML = '<span><b>' + pad(d) + '</b><i>' + T.d + '</i></span><span><b>' + pad(h) + '</b><i>' + T.h + '</i></span><span><b>' + pad(m) + '</b><i>' + T.m + '</i></span><span><b>' + pad(s) + '</b><i>' + T.s + '</i></span>';
      if (diff <= 0) { clearInterval(iv); if (onDone) onDone(); }
    }
    iv = setInterval(tick, 1000); tick();
    return iv;
  }

  /* ---------- Horizontale Galerie: Pfeile ---------- */
  function wireArrows(root) {
    var track = $('.sal-lb__track', root), prev = $('[data-lb-prev]', root), next = $('[data-lb-next]', root);
    if (!track || !prev || !next) return;
    function step() { var c = track.querySelector('.sal-lb__card'); return c ? (c.getBoundingClientRect().width + 12) * 2 : 400; }
    prev.onclick = function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); };
    next.onclick = function () { track.scrollBy({ left: step(), behavior: 'smooth' }); };
    function upd() { prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    if (!track._salWired) { track._salWired = true; track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); window.addEventListener('resize', upd, { passive: true }); }
    setTimeout(upd, 50);
  }

  function heartSvg() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2 0 3.5 1.1 5 3 1.5-1.9 3-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>'; }

  function cardHtml(it, i, opts) {
    var name = it.display_name || 'SALITE Fam';
    var ig = it.instagram ? '@' + String(it.instagram).replace(/^@/, '') : '';
    return '<figure class="sal-lb__card" data-id="' + it.id + '">' +
      '<div class="sal-lb__media"><img src="' + pubUrl(it.public_path, true) + '" alt="' + esc(name) + '" loading="' + (i < 3 ? 'eager' : 'lazy') + '" decoding="async" width="800" height="1000"></div>' +
      (opts.rank ? '<span class="sal-lb__rank">' + (i + 1) + '</span>' : '') +
      '<figcaption class="sal-lb__cap"><span class="sal-lb__who"><b>' + esc(name) + '</b>' + (ig ? '<em>' + esc(ig) + '</em>' : '') + '</span>' +
      (it.caption ? '<span class="sal-lb__txt">' + esc(it.caption) + '</span>' : '') + '</figcaption>' +
      (opts.likes ? '<button type="button" class="sal-lb__like" data-like="' + it.id + '" aria-pressed="false" aria-label="' + T.like + '"' + (opts.likeOff ? ' disabled' : '') + '>' + heartSvg() + '<span data-count>' + (it.likes || 0) + '</span></button>' : '') +
      '</figure>';
  }

  /* ============================================================
     Startseiten-Teaser (ohne Supabase-Bibliothek, nur REST)
     ============================================================ */
  function initTeaser(root) {
    wireArrows(root);
    if (!CFG.url || !CFG.key) return;
    rest('contests?select=*&order=starts_at.desc&limit=6').then(function (list) {
      var pc = pickContest(list), c = pc.contest, ph = phase(c);
      var timer = $('[data-lb-timer]', root), label = $('[data-lb-label]', root);
      if (ph === 'open') { label.textContent = T.endsIn; countdown(timer, c.ends_at); root.classList.add('is-open'); }
      else if (pc.upcoming) { label.textContent = T.startsIn; countdown(timer, pc.upcoming.starts_at); }
      else if (ph === 'ended') { label.textContent = T.ended; timer.innerHTML = ''; }
      if (!c) return;
      return rest('lookbook_public?select=*&contest_id=eq.' + c.id + '&order=likes.desc,created_at.asc&limit=10').then(function (items) {
        if (!items.length) return;
        var track = $('.sal-lb__track', root);
        track.innerHTML = items.map(function (it, i) { return cardHtml(it, i, { rank: false, likes: true, likeOff: true }); }).join('');
        $$('.sal-lb__card', track).forEach(function (card) { card.style.cursor = 'pointer'; card.onclick = function () { location.href = root.getAttribute('data-page'); }; });
        root.classList.add('has-items');
        wireArrows(root);
      });
    }).catch(function () {});
  }

  /* ============================================================
     Lookbook-Seite
     ============================================================ */
  function initPage(root) {
    if (!CFG.url || !CFG.key || !window.supabase) { root.classList.add('is-unconfigured'); $('[data-lb-label]', root).textContent = T.soon; return; }
    var sb = window.supabase.createClient(CFG.url, CFG.key, { auth: { persistSession: true, autoRefreshToken: true, storageKey: 'sal-lb-auth' } });
    var state = { contest: null, upcoming: null, phase: 'none', items: [], sort: 'top', liked: {}, user: null, pendingLike: null, file: null };
    var dlg = $('[data-lb-dialog]', root);
    var terms = root.getAttribute('data-terms') || '#', privacy = root.getAttribute('data-privacy') || '#';

    function setMsg(el, txt, ok) { el.textContent = txt || ''; el.classList.toggle('is-ok', !!ok); }

    /* ----- Auth ----- */
    sb.auth.getSession().then(function (r) { state.user = r.data.session ? r.data.session.user : null; afterAuth(); });
    sb.auth.onAuthStateChange(function (_e, session) { state.user = session ? session.user : null; });

    function afterAuth() {
      renderUserBar();
      if (state.user) loadLikes().then(paintLikes);
    }
    function renderUserBar() {
      var bar = $('[data-lb-userbar]', root); if (!bar) return;
      if (state.user) {
        bar.innerHTML = '<span>' + T.loggedAs + ' ' + esc(state.user.email) + '</span><button type="button" data-lb-logout>' + T.logout + '</button>'; bar.hidden = false;
        $('[data-lb-logout]', bar).onclick = function () { sb.auth.signOut().then(function () { state.user = null; state.liked = {}; paintLikes(); renderUserBar(); }); };
      } else { bar.hidden = true; bar.innerHTML = ''; }
    }

    /* ----- Daten ----- */
    function load() {
      return sb.from('contests').select('*').order('starts_at', { ascending: false }).limit(6).then(function (r) {
        var pc = pickContest(r.data || []); state.contest = pc.contest; state.upcoming = pc.upcoming; state.phase = phase(pc.contest);
        renderHead();
        if (!state.contest) { renderGallery(); return; }
        return sb.from('lookbook_public').select('*').eq('contest_id', state.contest.id).order('likes', { ascending: false }).order('created_at', { ascending: true }).then(function (r2) {
          state.items = r2.data || []; renderGallery();
        });
      });
    }
    function loadLikes() {
      if (!state.user) return Promise.resolve();
      return sb.from('likes').select('submission_id').eq('user_id', state.user.id).then(function (r) {
        state.liked = {}; (r.data || []).forEach(function (l) { state.liked[l.submission_id] = true; });
      });
    }

    /* ----- Kopfbereich ----- */
    var timerIv = null;
    function renderHead() {
      var label = $('[data-lb-label]', root), timer = $('[data-lb-timer]', root), prize = $('[data-lb-prize]', root), btn = $('[data-lb-open]', root);
      if (timerIv) clearInterval(timerIv);
      var c = state.contest, src = state.phase === 'open' ? c : (state.upcoming || c);
      prize.textContent = src && src.prize ? T.prize + ': ' + src.prize : '';
      btn.hidden = state.phase !== 'open';
      root.dataset.phase = state.phase;
      if (state.phase === 'open') { label.textContent = T.endsIn; timerIv = countdown(timer, c.ends_at, function () { load(); }); }
      else if (state.upcoming) { label.textContent = T.startsIn; timerIv = countdown(timer, state.upcoming.starts_at, function () { load(); }); }
      else if (state.phase === 'ended') { label.textContent = T.ended; timer.innerHTML = ''; }
      else { label.textContent = T.soon; timer.innerHTML = ''; }
    }

    /* ----- Galerie ----- */
    function sorted() {
      var a = state.items.slice();
      if (state.sort === 'new') a.sort(function (x, y) { return Date.parse(y.created_at) - Date.parse(x.created_at); });
      return a;
    }
    function renderGallery() {
      var track = $('.sal-lb__track', root), win = $('[data-lb-winner]', root);
      var items = sorted();
      if (state.phase === 'ended' && state.items.length) {
        var w = state.items[0];
        win.hidden = false;
        win.innerHTML = '<div class="sal-lb__win-media"><img src="' + pubUrl(w.public_path) + '" alt="' + esc(w.display_name || '') + '"></div>' +
          '<div class="sal-lb__win-info"><p class="sal-lb__eyebrow">' + T.winner + (state.contest.title ? ' · ' + esc(state.contest.title) : '') + '</p>' +
          '<h2>' + esc(w.display_name || 'SALITE Fam') + '</h2>' + (w.instagram ? '<p>@' + esc(String(w.instagram).replace(/^@/, '')) + '</p>' : '') +
          '<p class="sal-lb__win-likes">' + heartSvg() + ' ' + w.likes + ' ' + T.likes + '</p></div>';
      } else { win.hidden = true; win.innerHTML = ''; }
      if (!items.length) { track.innerHTML = '<p class="sal-lb__empty">' + T.empty + '</p>'; root.classList.remove('has-items'); return; }
      track.innerHTML = items.map(function (it, i) { return cardHtml(it, i, { rank: state.sort === 'top', likes: true, likeOff: state.phase !== 'open' }); }).join('');
      root.classList.add('has-items');
      paintLikes(); wireArrows(root);
    }
    function paintLikes() {
      $$('[data-like]', root).forEach(function (b) { var on = !!state.liked[b.getAttribute('data-like')]; b.classList.toggle('is-liked', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? T.liked : T.like); });
    }
    $$('[data-lb-sort]', root).forEach(function (b) {
      b.onclick = function () { state.sort = b.getAttribute('data-lb-sort'); $$('[data-lb-sort]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); renderGallery(); $('.sal-lb__track', root).scrollLeft = 0; };
    });

    /* ----- Liken ----- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-like]'); if (!b || b.disabled) return;
      var id = b.getAttribute('data-like');
      if (!state.user) { state.pendingLike = id; openDialog(T.likeNeedsLogin); return; }
      toggleLike(id, b);
    });
    function toggleLike(id, b) {
      b = b || $('[data-like="' + id + '"]', root); if (!b) return;
      var on = !!state.liked[id], cnt = $('[data-count]', b), it = state.items.filter(function (x) { return x.id === id; })[0];
      b.disabled = true;
      state.liked[id] = !on; if (it) it.likes += on ? -1 : 1; if (it) cnt.textContent = it.likes; paintLikes();
      var q = on ? sb.from('likes').delete().eq('submission_id', id).eq('user_id', state.user.id) : sb.from('likes').insert({ submission_id: id, user_id: state.user.id });
      q.then(function (r) {
        b.disabled = false;
        if (r.error && r.error.code !== '23505') {
          state.liked[id] = on; if (it) { it.likes += on ? 1 : -1; cnt.textContent = it.likes; } paintLikes();
          toast(r.error.code === '42501' ? T.ownLike : T.error);
        }
      });
    }

    var toastT; function toast(t) { var el = $('[data-lb-toast]', root); el.textContent = t; el.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('is-on'); }, 3200); }

    /* ----- Dialog ----- */
    function openDialog(note) {
      if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
      document.documentElement.classList.add('sal-lb-lock');
      show(state.user ? 'upload' : 'email', note);
    }
    function closeDialog() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); document.documentElement.classList.remove('sal-lb-lock'); }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('sal-lb-lock'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDialog(); });
    $$('[data-lb-close]', dlg).forEach(function (b) { b.onclick = closeDialog; });
    $('[data-lb-open]', root).onclick = function () { state.pendingLike = null; openDialog(); };

    function show(step, note) {
      $$('[data-step]', dlg).forEach(function (s) { s.hidden = s.getAttribute('data-step') !== step; });
      if (step === 'email') { setMsg($('[data-lb-note]', dlg), note || T.emailText); setMsg($('[data-lb-err-email]', dlg), ''); setTimeout(function () { $('[name=lb_email]', dlg).focus(); }, 30); }
      if (step === 'upload') { renderMine(); setMsg($('[data-lb-err-up]', dlg), ''); }
    }

    var lastEmail = '';
    $('[data-lb-form-email]', dlg).onsubmit = function (e) {
      e.preventDefault(); var em = $('[name=lb_email]', dlg).value.trim(); if (!em) return;
      var btn = $('button[type=submit]', e.target); btn.disabled = true;
      sb.auth.signInWithOtp({ email: em, options: { shouldCreateUser: true } }).then(function (r) {
        btn.disabled = false;
        if (r.error) { setMsg($('[data-lb-err-email]', dlg), r.error.status === 429 ? T.rate : T.error); return; }
        lastEmail = em; $('[data-lb-sent]', dlg).textContent = T.codeSent + ' ' + em; setMsg($('[data-lb-err-code]', dlg), ''); show('code');
        setTimeout(function () { $('[name=lb_code]', dlg).focus(); }, 30);
      });
    };
    $('[data-lb-resend]', dlg).onclick = function () { show('email'); $('[name=lb_email]', dlg).value = lastEmail; };
    $('[data-lb-form-code]', dlg).onsubmit = function (e) {
      e.preventDefault(); var code = $('[name=lb_code]', dlg).value.replace(/\D/g, ''); if (code.length < 6) return;
      var btn = $('button[type=submit]', e.target); btn.disabled = true;
      sb.auth.verifyOtp({ email: lastEmail, token: code, type: 'email' }).then(function (r) {
        btn.disabled = false;
        if (r.error) { setMsg($('[data-lb-err-code]', dlg), T.wrongCode); return; }
        state.user = r.data.user; renderUserBar();
        loadLikes().then(function () {
          paintLikes();
          if (state.pendingLike) { var id = state.pendingLike; state.pendingLike = null; closeDialog(); if (!state.liked[id]) toggleLike(id); }
          else show('upload');
        });
      });
    };

    /* ----- Upload ----- */
    var fileIn = $('[name=lb_file]', dlg), prev = $('[data-lb-preview]', dlg);
    fileIn.onchange = function () {
      var f = fileIn.files && fileIn.files[0]; if (!f) return;
      resize(f, 1800).then(function (blob) {
        state.file = blob; prev.innerHTML = '<img alt="" src="' + URL.createObjectURL(blob) + '">'; prev.hidden = false;
        $('[data-lb-pick-label]', dlg).textContent = T.change;
      }).catch(function () { toast(T.error); });
    };
    function resize(file, max) {
      return new Promise(function (res, rej) {
        var url = URL.createObjectURL(file), img = new Image();
        img.onload = function () {
          var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, max / Math.max(w, h));
          var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
          c.toBlob(function (b) { b ? res(b) : rej(); }, 'image/jpeg', 0.86); // entfernt nebenbei EXIF/GPS-Daten
        };
        img.onerror = rej; img.src = url;
      });
    }
    function uid() { return (window.crypto && crypto.randomUUID ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(16).slice(2))); }
    $('[data-lb-form-up]', dlg).onsubmit = function (e) {
      e.preventDefault(); var err = $('[data-lb-err-up]', dlg);
      if (state.phase !== 'open') return setMsg(err, T.closed);
      if (!state.file) return setMsg(err, T.needPhoto);
      var name = $('[name=lb_name]', dlg).value.trim(); if (!name) return setMsg(err, T.needName);
      if (!$('[name=lb_terms]', dlg).checked || !$('[name=lb_rights]', dlg).checked) return setMsg(err, T.needConsent);
      var btn = $('button[type=submit]', e.target); btn.disabled = true; btn.textContent = T.sending; setMsg(err, '');
      var path = state.user.id + '/' + uid() + '.jpg';
      sb.storage.from('lookbook').upload(path, state.file, { contentType: 'image/jpeg', upsert: false }).then(function (r) {
        if (r.error) throw r.error;
        return sb.from('submissions').insert({
          contest_id: state.contest.id, user_id: state.user.id, image_path: path,
          display_name: name.slice(0, 40), instagram: $('[name=lb_insta]', dlg).value.trim().replace(/^@/, '').slice(0, 30) || null,
          caption: $('[name=lb_caption]', dlg).value.trim().slice(0, 140) || null, consent_terms: true, consent_rights: true
        }).then(function (r2) {
          if (r2.error) { sb.storage.from('lookbook').remove([path]); throw r2.error; }
        });
      }).then(function () {
        btn.disabled = false; btn.textContent = T.send; e.target.reset(); state.file = null; prev.hidden = true; prev.innerHTML = '';
        $('[data-lb-pick-label]', dlg).textContent = T.pick; setMsg(err, T.thanks, true); renderMine();
      }).catch(function (x) {
        btn.disabled = false; btn.textContent = T.send;
        setMsg(err, x && /limit_reached/.test(x.message || '') ? T.limit : (x && String(x.statusCode) === '403' ? T.closed : T.error));
      });
    };
    function renderMine() {
      var box = $('[data-lb-mine]', dlg); if (!state.user || !box) return;
      sb.from('submissions').select('id,status,created_at').eq('user_id', state.user.id).order('created_at', { ascending: false }).then(function (r) {
        var rows = r.data || []; if (!rows.length) { box.hidden = true; return; }
        box.hidden = false;
        box.innerHTML = '<p class="sal-lb__eyebrow">' + T.mine + '</p><ul>' + rows.map(function (s) { return '<li><span>' + new Date(s.created_at).toLocaleDateString(DE ? 'de-DE' : 'en-GB') + '</span><b class="st-' + s.status + '">' + T['st_' + s.status] + '</b></li>'; }).join('') + '</ul>';
      });
    }

    $('[data-lb-terms-label]', dlg).innerHTML = T.cTerms.replace('{terms}', terms).replace('{privacy}', privacy);
    $('[data-lb-rights-label]', dlg).textContent = T.cRights;

    load().catch(function () {});
    setInterval(function () {
      if (state.phase !== 'open' || document.hidden || !state.contest) return;
      sb.from('lookbook_public').select('id,likes').eq('contest_id', state.contest.id).then(function (r) {
        (r.data || []).forEach(function (n) { var it = state.items.filter(function (x) { return x.id === n.id; })[0]; if (it && it.likes !== n.likes) { it.likes = n.likes; var b = $('[data-like="' + n.id + '"] [data-count]', root); if (b) b.textContent = n.likes; } });
      });
    }, 60000);
  }

  /* ============================================================
     Admin-Seite (Freigabe)
     ============================================================ */
  function initAdmin(root) {
    if (!CFG.url || !CFG.key || !window.supabase) { $('[data-adm-msg]', root).textContent = 'Supabase ist noch nicht verbunden.'; return; }
    var sb = window.supabase.createClient(CFG.url, CFG.key, { auth: { persistSession: true, autoRefreshToken: true, storageKey: 'sal-lb-auth' } });
    var tab = 'pending', email = '';
    var body = $('[data-adm-body]', root), login = $('[data-adm-login]', root), msg = $('[data-adm-msg]', root);

    function say(t) { msg.textContent = t || ''; }
    sb.auth.getSession().then(function (r) { if (r.data.session) check(); else login.hidden = false; });

    $('[data-adm-email]', root).onsubmit = function (e) {
      e.preventDefault(); email = $('[name=adm_email]', root).value.trim();
      sb.auth.signInWithOtp({ email: email, options: { shouldCreateUser: true } }).then(function (r) { say(r.error ? 'Fehler: ' + r.error.message : 'Code gesendet an ' + email); if (!r.error) $('[data-adm-code]', root).hidden = false; });
    };
    $('[data-adm-code]', root).onsubmit = function (e) {
      e.preventDefault();
      sb.auth.verifyOtp({ email: email, token: $('[name=adm_code]', root).value.trim(), type: 'email' }).then(function (r) { if (r.error) return say('Code falsch oder abgelaufen.'); check(); });
    };
    function check() {
      sb.rpc('is_admin').then(function (r) {
        if (!r.data) { login.hidden = false; say('Dieses Konto hat keine Admin-Rechte.'); return; }
        login.hidden = true; root.classList.add('is-admin'); say(''); loadContests(); list();
      });
    }
    $$('[data-adm-tab]', root).forEach(function (b) { b.onclick = function () { tab = b.getAttribute('data-adm-tab'); $$('[data-adm-tab]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); }); list(); }; });
    $('[data-adm-logout]', root).onclick = function () { sb.auth.signOut().then(function () { location.reload(); }); };

    function list() {
      body.innerHTML = '<p>Lädt …</p>';
      sb.rpc('admin_list', { p_status: tab }).then(function (r) {
        if (r.error) { body.innerHTML = '<p>Fehler: ' + esc(r.error.message) + '</p>'; return; }
        var rows = r.data || [];
        if (!rows.length) { body.innerHTML = '<p class="sal-adm__empty">Keine Einträge.</p>'; return; }
        var paths = rows.map(function (x) { return x.image_path; });
        sb.storage.from('lookbook').createSignedUrls(paths, 3600).then(function (s) {
          var urls = {}; (s.data || []).forEach(function (u) { urls[u.path] = u.signedUrl; });
          body.innerHTML = rows.map(function (x, i) {
            return '<article class="sal-adm__card" data-id="' + x.id + '">' +
              '<a href="' + (urls[x.image_path] || '#') + '" target="_blank"><img loading="lazy" src="' + (urls[x.image_path] || '') + '" alt=""></a>' +
              '<div class="sal-adm__meta">' + (tab === 'approved' ? '<p class="sal-adm__rank">Platz ' + (i + 1) + ' · ' + x.likes + ' Likes</p>' : '') +
              '<p><b>' + esc(x.display_name || '–') + '</b>' + (x.instagram ? ' · @' + esc(x.instagram) : '') + '</p>' +
              (x.caption ? '<p>' + esc(x.caption) + '</p>' : '') +
              '<p class="sal-adm__mail">' + esc(x.email) + ' <button type="button" data-copy="' + esc(x.email) + '">kopieren</button></p>' +
              '<p class="sal-adm__date">' + new Date(x.created_at).toLocaleString('de-DE') + '</p>' +
              '<div class="sal-adm__btns">' +
              (x.status !== 'approved' ? '<button type="button" data-approve>Freigeben</button>' : '') +
              (x.status !== 'rejected' ? '<button type="button" data-reject class="is-ghost">' + (x.status === 'approved' ? 'Offline nehmen' : 'Ablehnen') + '</button>' : '') +
              '</div></div></article>';
          }).join('');
          rows.forEach(function (x) {
            var c = $('[data-id="' + x.id + '"]', body), a = $('[data-approve]', c), rj = $('[data-reject]', c);
            if (a) a.onclick = function () { approve(x, c); }; if (rj) rj.onclick = function () { reject(x, c); };
          });
          $$('[data-copy]', body).forEach(function (b) { b.onclick = function () { if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-copy')); b.textContent = 'kopiert'; }; });
        });
      });
    }
    function shrink(blob, max) {
      return createImageBitmap(blob).then(function (bm) {
        var k = Math.min(1, max / Math.max(bm.width, bm.height)), c = document.createElement('canvas');
        c.width = Math.round(bm.width * k); c.height = Math.round(bm.height * k); c.getContext('2d').drawImage(bm, 0, 0, c.width, c.height);
        return new Promise(function (res) { c.toBlob(res, 'image/jpeg', 0.84); });
      });
    }
    function approve(x, card) {
      card.classList.add('is-busy');
      var big = x.id + '.jpg', small = x.id + '-s.jpg';
      sb.storage.from('lookbook').download(x.image_path).then(function (r) {
        if (r.error) throw r.error;
        return Promise.all([shrink(r.data, 1600), shrink(r.data, 800)]);
      }).then(function (b) {
        return Promise.all([
          sb.storage.from('lookbook-public').upload(big, b[0], { contentType: 'image/jpeg', upsert: true, cacheControl: '31536000' }),
          sb.storage.from('lookbook-public').upload(small, b[1], { contentType: 'image/jpeg', upsert: true, cacheControl: '31536000' })
        ]);
      }).then(function (u) {
        if (u[0].error || u[1].error) throw (u[0].error || u[1].error);
        return sb.from('submissions').update({ status: 'approved', public_path: big, reviewed_at: new Date().toISOString() }).eq('id', x.id);
      }).then(function (r) { if (r.error) throw r.error; card.remove(); })
        .catch(function (e) { card.classList.remove('is-busy'); say('Fehler beim Freigeben: ' + (e.message || e)); });
    }
    function reject(x, card) {
      card.classList.add('is-busy');
      var rm = x.public_path ? sb.storage.from('lookbook-public').remove([x.public_path, x.public_path.replace(/\.jpg$/, '-s.jpg')]) : Promise.resolve();
      Promise.resolve(rm).then(function () {
        return sb.from('submissions').update({ status: 'rejected', public_path: null, reviewed_at: new Date().toISOString() }).eq('id', x.id);
      }).then(function (r) { if (r.error) throw r.error; card.remove(); })
        .catch(function (e) { card.classList.remove('is-busy'); say('Fehler: ' + (e.message || e)); });
    }

    function loadContests() {
      var box = $('[data-adm-contests]', root);
      sb.from('contests').select('*').order('starts_at', { ascending: false }).limit(10).then(function (r) {
        var rows = r.data || [];
        box.innerHTML = rows.length ? '<ul>' + rows.map(function (c) {
          var p = phase(c);
          return '<li><b>' + esc(c.title) + '</b> · ' + new Date(c.starts_at).toLocaleString('de-DE') + ' – ' + new Date(c.ends_at).toLocaleString('de-DE') +
            (c.prize ? ' · ' + esc(c.prize) : '') + ' · <em>' + ({ before: 'geplant', open: 'läuft', ended: 'beendet' }[p]) + '</em> <button type="button" data-del-contest="' + c.id + '">löschen</button></li>';
        }).join('') + '</ul>' : '<p>Noch keine Einsendephase angelegt.</p>';
        $$('[data-del-contest]', box).forEach(function (b) { b.onclick = function () { if (!window.confirm('Einsendephase inkl. aller Einsendungen löschen?')) return; sb.from('contests').delete().eq('id', b.getAttribute('data-del-contest')).then(loadContests); }; });
      });
    }
    $('[data-adm-new]', root).onsubmit = function (e) {
      e.preventDefault(); var f = e.target;
      var row = { title: f.c_title.value || 'SALITE Lookbook', prize: f.c_prize.value || null,
        starts_at: new Date(f.c_start.value).toISOString(), ends_at: new Date(f.c_end.value).toISOString(), max_per_user: parseInt(f.c_max.value || '3', 10) };
      sb.from('contests').insert(row).then(function (r) { say(r.error ? 'Fehler: ' + r.error.message : 'Einsendephase gespeichert.'); if (!r.error) { f.reset(); loadContests(); } });
    };
  }

  function boot() {
    $$('[data-sal-lb-teaser]').forEach(initTeaser);
    $$('[data-sal-lb-page]').forEach(initPage);
    $$('[data-sal-lb-admin]').forEach(initAdmin);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
